export enum SiteStatus {
  Uploading = -1,
  Offline = 0,
  Online = 1,
  Processing = 2,
}
